import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { User, Clock } from 'lucide-react';
import { teamMembers } from '../data/mock';

const Team = () => {
  return (
    <section id="team" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Unser Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ein erfahrenes und eingespieltes Team steht Ihnen mit Kompetenz, 
            Einfühlungsvermögen und jahrelanger Erfahrung zur Seite.
          </p>
        </div>

        {/* Dr. Weiß - Featured */}
        <div className="mb-16">
          <Card className="bg-gradient-to-r from-red-50 to-red-100 border-red-200 overflow-hidden">
            <CardContent className="p-0">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
                <div className="lg:col-span-1 bg-gradient-to-br from-red-500 to-red-600 p-8 flex items-center justify-center">
                  <div className="w-40 h-40 rounded-full overflow-hidden bg-white/20 backdrop-blur-sm border-4 border-white/30">
                    {teamMembers[0].image ? (
                      <img 
                        src={teamMembers[0].image} 
                        alt={teamMembers[0].name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <User className="h-20 w-20 text-white" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="lg:col-span-2 p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">
                    {teamMembers[0].name}
                  </h3>
                  <p className="text-red-600 font-medium mb-4 text-center">
                    {teamMembers[0].role}
                  </p>
                  <p className="text-gray-600 mb-4 leading-relaxed text-center">
                    {teamMembers[0].description}
                  </p>
                  <div className="flex items-center justify-center text-sm text-gray-500">
                    <Clock className="h-4 w-4 mr-2" />
                    <span>{teamMembers[0].experience}</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Team Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.slice(1).map((member) => (
            <Card 
              key={member.id}
              className="bg-white hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-red-200 group"
            >
              <CardHeader className="text-center pb-4">
                <div className="w-24 h-24 mx-auto mb-4 overflow-hidden rounded-full bg-gradient-to-br from-red-100 to-red-200 group-hover:from-red-200 group-hover:to-red-300 transition-all duration-300">
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <User className="h-12 w-12 text-red-600" />
                    </div>
                  )}
                </div>
                <CardTitle className="text-xl font-semibold text-gray-900 group-hover:text-red-700 transition-colors duration-300">
                  {member.name}
                </CardTitle>
                <p className="text-red-600 font-medium text-sm">
                  {member.role}
                </p>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 text-center">
                  {member.description}
                </p>
                <div className="flex items-center justify-center text-xs text-gray-500">
                  <Clock className="h-3 w-3 mr-1" />
                  <span>{member.experience}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-2xl p-8 border border-red-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Gemeinsam für Ihre Gesundheit
            </h3>
            <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Unser eingespieltes Team arbeitet Hand in Hand, um Ihnen die bestmögliche 
              Betreuung zu bieten. Mit langjähriger Erfahrung und kontinuierlicher 
              Weiterbildung stehen wir Ihnen kompetent zur Seite.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;